import { create } from 'zustand'

type ScreenSize = '3xl' | '2xl' | 'xl' | 'lg' | 'md' | 'sm'

const breakpoints: Record<ScreenSize, number> = {
  'sm': 0,
  'md': 768,
  'lg': 1024,
  'xl': 1280,
  '2xl': 1536,
  '3xl': 1792,
}

const getScreenSize = (width: number): ScreenSize => {
  if (width >= breakpoints['3xl']) return '3xl'
  if (width >= breakpoints['2xl']) return '2xl'
  if (width >= breakpoints.xl) return 'xl'
  if (width >= breakpoints.lg) return 'lg'
  if (width >= breakpoints.md) return 'md'
  return 'sm'
}

type ScreenSizeState = {
  onScreenWidthChanged: (width: number) => void
  screenSize: ScreenSize | undefined
  setScreenSize: (screenSize: ScreenSize) => void
}

const useScreenSizeStore = create<ScreenSizeState>(set => ({
  onScreenWidthChanged: width => set({ screenSize: getScreenSize(width) }),
  screenSize: undefined,
  setScreenSize: screenSize => set({ screenSize }),
}))

export const useScreenSize = () => useScreenSizeStore(state => state.screenSize)

export const useIsLgOrAbove = () =>
  useScreenSizeStore(state =>
    state.screenSize
      ? breakpoints[state.screenSize] >= breakpoints.lg
      : false,
  )

export const useIsXlOrAbove = () =>
  useScreenSizeStore(state =>
    state.screenSize
      ? breakpoints[state.screenSize] >= breakpoints.xl
      : false,
  )

export const useScreenWidthChanged = () => useScreenSizeStore(state => state.onScreenWidthChanged)
